module.exports = {"410381001":"商城街道","410381002":"槐新街道","410381003":"首阳山街道","410381004":"伊洛街道","410381103":"翟镇","410381104":"岳滩镇","410381105":"顾县镇","410381106":"缑氏镇","410381107":"府店镇","410381108":"高龙镇","410381113":"山化镇","410381114":"邙岭镇","410381115":"大口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410381.json
// module id = 1553
// module chunks = 0